import ProfileHeaderPresentation from './HeaderPresentation'
import ProfileSkills from './Skills'
import RadarGraphic from './RadarGraphic'

export default function Header({ identity, skills, radar, state, toggleCategory, toggleSkill, careers, style, networking }) {
    return (
        <div className="header">
            <div className="fleft h-100 w-55">
                <ProfileHeaderPresentation 
                    identity={ identity }
                    careers={ careers }
                    style={ style }
                    networking={ networking }
                />
                <ProfileSkills 
                    skills={ skills } 
                    toggleSkill={toggleSkill} 
                    style={ style }
                />
            </div>
            <div className="fright w-45 graphic">
                <RadarGraphic 
                    radar={ radar } 
                    state={ state } 
                    toggleCategory={ toggleCategory }
                />
            </div>
        </div>
    )
}